var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");
'use strict';$CLJS.CG=new $CLJS.M(null,"s","s",1705939918);